import request from '../utils/request'

// 发送短信验证码
export function sendSms (phone) {
  return request({
    method: 'GET',
    url: `/api/sms/sendSms?telephone=${phone}`
  })
}

// 预约咨询
export function order (params) {
  return request({
    method: 'POST',
    url: 'api/appointment/saveData',
    data: params
  })
}

// 获取省份列表
export function getProvinceList (id) {
  return request({
    method: 'GET',
    url: `api/province/getProvinceList`
  })
}

// 获取城市名称
export function getCityList (id) {
  return request({
    method: 'GET',
    url: `api/province/getCityList?id=${id}`
  })
}

// 获取区域
export function getDistrictList (id) {
  return request({
    method: 'GET',
    url: `api/province/getDistrictList?id=${id}`
  })
}

// 通过省份id获取门店列表
export function getStoreListByProvinceId (id) {
  return request({
    method: 'GET',
    url: 'api/store/getStoreListByProvinceId?province_id='+id
  })
}

// 获取门店列表
export function getStoreByParams (params) {
  return request({
    method: 'POST',
    url: 'api/store/getStoreByParams',
    data: params
  })
}

// 获取商家列表
export function getStoreList (params) {
  return request({
    method: 'POST',
    url: 'api/store/getStoreList',
    data: params
  })
}

// 获取顶部导航
export function getTopList () {
  return request({
    method: 'GET',
    url: 'api/nav/getTopList'
  })
}

// 获取banner图
export function getBannerById (id) {
  return request({
    method: 'GET',
    url: `api/banner/getBannerById?id=${id}`
  })
}

// 户型/房型列表
export function getHouseList (id) {
  return request({
    method: 'GET',
    url: `api/house_type/getList?id=${id}`
  })
}

// 根据门店id获取列表
export function getListByStore (params) {
  return request({
    method: 'POST',
    url: 'api/house_type/getListByStore',
    data: params
  })
}

// 新闻列表
export function getnewsList (params) {
  return request({
    method: 'POST',
    url: 'api/news/getList',
    data: params
  })
}

// 新闻-根据类型获取列表
export function getListByTypeId (params) {
  return request({
    method: 'POST',
    url: 'api/news/getListByTypeId',
    data: params
  })
}

// 新闻详情
export function getnewsDetail (id) {
  return request({
    method: 'GET',
    url: `api/news/detail?id=${id}`
  })
}

// 活动-列表
export function getactivityList (params) {
  return request({
    method: 'POST',
    url: 'api/activity/getList',
    data: params
  })
}

// 添加合作留言
export function addMessageData (params) {
  return request({
    method: 'POST',
    url: 'api/message/submit_data',
    data: params
  })
}
